import { render, staticRenderFns } from "./signinDia.vue?vue&type=template&id=2321d3e4&scoped=true"
import script from "./signinDia.vue?vue&type=script&lang=js"
export * from "./signinDia.vue?vue&type=script&lang=js"
import style0 from "./signinDia.vue?vue&type=style&index=0&id=2321d3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2321d3e4",
  null
  
)

export default component.exports